/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ComponentRef, RefObject } from 'react';
import { Spinner } from '@ds';
import ReactPlayer from 'react-player/file';
import { TfiArrowCircleLeft, TfiArrowCircleRight } from 'react-icons/tfi';
import { ClinicalMediaType } from '@/api/apis/case';
import { getFileUrl } from '@/api/utils';

type MediaPreviewContentProps = {
  currentMedia: ClinicalMediaType;
  currentIndex: number;
  mediaLength: number;
  scale: number;
  isImageLoading: boolean;
  loadedImageSrc: string | null;
  onPrev: () => void;
  onNext: () => void;
  playerRef: RefObject<ComponentRef<typeof ReactPlayer> | null>;
  useDirectPath?: boolean;
};

export const MediaPreviewContent = ({
  currentMedia,
  currentIndex,
  mediaLength,
  scale,
  isImageLoading,
  loadedImageSrc,
  onPrev,
  onNext,
  playerRef,
  useDirectPath = false,
}: MediaPreviewContentProps) => {
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === mediaLength - 1;

  return (
    <div className="flex h-full min-h-0 w-full items-center justify-center">
      <span
        className={`text-xl font-semibold text-white ${isFirst ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
        onClick={isFirst ? undefined : onPrev}
      >
        <TfiArrowCircleLeft size={24} color="white" />
      </span>

      <div className="relative flex h-full min-h-0 w-full justify-center">
        <div
          className="flex h-full min-h-0 w-full items-center justify-center"
          style={{
            transform: `scale(${scale})`,
            transition: 'transform 0.2s ease-in-out',
          }}
        >
          {currentMedia.file.mediaType === 'Video' ? (
            <div className="flex max-h-full max-w-full items-center justify-center">
              <ReactPlayer
                ref={playerRef}
                url={useDirectPath ? currentMedia.file.path : getFileUrl(currentMedia.file.path)}
                width="100%"
                height="100%"
                controls
                config={{
                  attributes: {
                    playsInline: true,
                  },
                }}
              />
            </div>
          ) : (
            <>
              {isImageLoading && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <Spinner size="lg" />
                </div>
              )}

              {loadedImageSrc && (
                <img
                  src={loadedImageSrc}
                  alt={currentMedia.file.fileName}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>

      <span
        className={`ml-4 ${isLast ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
        onClick={isLast ? undefined : onNext}
      >
        <TfiArrowCircleRight size={24} color="white" />
      </span>
    </div>
  );
};
